import React, {useCallback, useEffect, useState} from "react";
import "./SupabaseConnectionComponent.scss";
import commonService from "@/services/common.service.ts";
import {LOCAL_STORAGE_LOGGED_IN_USER_DATA} from "@/constants/Misc.tsx";
import {ImageConfig} from "@/constants";
import {CircleCheckBig, CircleX, Loader2} from "lucide-react";


const SupabaseConnectionComponent = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [connectionSuccess, setConnectionSuccess] = useState<boolean>(false);
    const [countdown, setCountdown] = useState<number>(3);
    // const [error, setError] = useState<string | null>(null);
    // const dispatch = useDispatch();

    // Function to fetch URL parameters
    const getUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const params: { [key: string]: string } = {};
        urlParams.forEach((value, key) => {
            params[key] = value;
        });
        return params;
    };

    // Function to call API with URL parameters
    const fetchSessionId = useCallback(async () => {
        setLoading(true);
        const params = getUrlParams();
        const paramsString = `?code=${params.code}&state=${params.state}`;
        try {
            commonService._project_service.connectSupabaseAuth(paramsString)
                .then(response => {
                    const currentUser = localStorage.getItem(LOCAL_STORAGE_LOGGED_IN_USER_DATA);
                    localStorage.setItem(LOCAL_STORAGE_LOGGED_IN_USER_DATA, JSON.stringify({
                        ...JSON.parse(currentUser || '{}'),
                        supabase_cred_id: params.state,
                        supabaseOrg: response?.data?.supabaseOrg,
                    }));
                    // Set connection success and start countdown
                    setLoading(false);
                    setConnectionSuccess(true);
                })
            // Update local storage

        } catch (error: any) {
            setLoading(false);
            setConnectionSuccess(false)
            // setError(error?.detail || "Error connecting to Supabase");
            commonService._alert.showToast(error?.detail || "Error connecting to Supabase");
        }
    }, []);



    useEffect(() => {
        fetchSessionId();
    }, [fetchSessionId]);

    // Countdown and window close effect
    useEffect(() => {
        let countdownInterval: NodeJS.Timeout;
        if (connectionSuccess) {
            countdownInterval = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown <= 1) {
                        clearInterval(countdownInterval);
                        window.close();
                        return 0;
                    }
                    return prevCountdown - 1;
                });
            }, 1000);
        }

        return () => {
            if (countdownInterval) {
                clearInterval(countdownInterval);
            }
        };
    }, [connectionSuccess]);

    return (
        <div className="supabase-connection-component flex justify-center items-center h-full">
            <div className={'border-1 max-w-5xl p-10'}>
                <div className={'flex justify-center items-center '}>
                    <div className={'super-engineer-icon mr-8'}>
                        <ImageConfig.LogoSmallIcon />
                    </div>
                    <div>
                        {loading ? (
                            <Loader2 className={"animate-spin"}/>
                        ) : connectionSuccess ? (
                            <CircleCheckBig color={'green'}/>
                        ) : (<CircleX color={'red'}/>)}
                    </div>
                    <div className={'super-engineer-icon ml-8'}>
                        <ImageConfig.SupabaseLogoIcon/>
                    </div>
                </div>
                <div className={'text-center mt-4 text-[var(--secondary-foreground)] font-medium text-lg'}>
                    {loading
                        ? "Connecting Supabase with SuperEngineer"
                        : connectionSuccess
                            ? `Successfully connected to Supabase.\n This window will close in ${countdown} seconds.`
                            : "Connection failed"
                    }
                </div>
            </div>
        </div>
    );
};

export default SupabaseConnectionComponent;
